module.exports = __webpack_public_path__ + "img/user12.45c36bf3.jpg";